<template>
	<div class="content">

		<div class="content-wrap">
			<div class="container">
				<div class="list">
					<div>
						<router-link to="/helpinapp/faqs" class="sub-menu">
						<p class="faq-section" v-html="l10.All_FAQ_tab1_Title1">

						</p></router-link>
					</div>
					<div>

						<div v-for="(value, key) in generalFaqs">
							<!-- <input type="radio" name="faqsection" :id="value.id" :value="value.id" v-model="mode"/> -->
							<!-- <label  :for="value.id"> -->
								<router-link :to="{ name: 'HelpAppDetail', params: {subject:'general',target:value.id} }"><p class="faq-section" >

								{{value.name}}
							</p></router-link>
						<!-- </label> -->
						</div>

						<div v-if="lang === 'en'">

								<router-link to="/helpinapp/school"><p class="faq-section" >
									Todo Math for school
								</p></router-link>


						</div>

					</div>
					<div>

							<a :class="[$route.path.includes('contact')?'router-link-active':'']" onclick="location.href='/helpinapp/contact'"><p class="faq-section" v-html="l10.All_FAQ_tab2_Title1">
								Contact us
							</p></a>


					</div>

				</div>
				<div class="body">
					<div v-if="mode !== 'search' && mode !== 'contact'">
						<p v-if="headTitle" class="head-title" v-html="headTitle">

						</p>
						<div v-for="item in listedContent" class="question">

							<p class="section-title" v-if="mode ==='faqs'">
								<!-- {{item.sectionTitle?item.sectionTitle:'null'}} -->
							</p>
							<input type="checkbox" :id="item.id" v-model="openTarget[item.id]"/>
							<label :for="item.id"><p class="content-title" v-html="item.title"  >

							</p></label>

							<p v-html="item.body" class="question-body">

							</p>
						</div>
					</div>
					<div v-if="mode === 'search'">

						<div class="search-title">
							<span v-html="l10.All_FAQ_Body_Title1_Description2"> </span>
							<div v-for="word in searchWordList" class="searched-word">
								<span v-html="word.replace(/(<([^>]+)>)/gi, '')"></span>
								<div class="remove" @click="$emit('removeWord', word)">

								</div>
							</div>
						</div>
						<p v-if="listedContent.length == 0" v-html="l10.All_FAQ_Body_Title1_Description3" class="no-result">

						</p>
						<div v-for="item in listedContent" class="question">
							<p class="section-title" >
								{{item.sectionTitle}}
							</p>

							<input type="checkbox" :id="item.id" v-model="openTarget[item.id]"/>
							<label :for="item.id"><p class="content-title" v-html="item.title"  >

							</p></label>
							<p v-html="item.body" class="question-body">

							</p>
						</div>
					</div>

					<div class="contact-form" v-if="mode === 'contact'">
						<p class="head-title" v-html="l10.All_FAQ_tab2_Title1">

						</p>
						<div :class="[contactUsForm.error.email]">
							<p class="email">
								<span v-html="l10.All_FAQ_Body_Title2_Subtitle1"></span>
								<span v-if="contactUsForm.error.email ==='blank-error'" class="error-text"  v-html="l10.All_FAQ_Body_Title2_Description1"></span>
								<span v-if="contactUsForm.error.email ==='form-error'" class="error-text" v-html="l10.All_FAQ_Body_Title2_Description2"></span>
							</p>
							<input id="email" @blur="checkEmail()" v-model="contactUsForm.value.email" type="text" placeholder="example@email.com" />
						</div>
						<div :class="{'blank-error':contactUsForm.error.subject}">
							<p class="email">
								<span v-html="l10.All_FAQ_Body_Title2_Subtitle2"></span>
								<span v-if="contactUsForm.error.subject ==='blank-error'" class="error-text" v-html="l10.All_FAQ_Body_Title2_Description1"></span>
							</p>
							<input type="text" v-model="contactUsForm.value.subject" :placeholder="l10.All_FAQ_Body_Title2_Subtitle2_Description1" />
						</div>
						<div :class="{'blank-error':contactUsForm.error.description}">
							<p class="email">
								<span  v-html="l10.All_FAQ_Body_Title2_Subtitle3"></span>
								<span v-if="contactUsForm.error.description ==='blank-error'" class="error-text" v-html="l10.All_FAQ_Body_Title2_Description1"></span>
							</p>
							<textarea v-model="contactUsForm.value.description" :placeholder="l10.All_FAQ_Body_Title2_Subtitle3_Description1"></textarea>
						</div>
						<div>
							<div class="submit-btn" @click="sendEmail()">
								<span v-html="l10.All_FAQ_Body_Title2_Button1"></span>
							</div>
						</div>
					</div>
					<div v-if="mode !== 'contact'" class="move-contact">

						<a  onclick="location.href='/helpinapp/contact'"><p class="faq-section" v-html="l10.All_FAQ_Body_Title1_Button1">
							Contact us
						</p></a>
					</div>
				</div>
			</div>
		</div>

	</div>

</template>
<script>




export default {
  name: 'Help',
	props:['mode','generalFaqs','schoolFaqs','listedContent','headTitle','l10', 'contactUsForm',"searchWordList"],
	components:{},

	methods:{
		checkEmail(){
			this.$emit('checkEmail');

		},
		sendEmail(){
			this.$emit('sendEmail');

		},
		searchFaq(){

			this.$emit('searchFaq');
		},
		toggleFaqArea($event, id){
			$event.target.classList.toggle('open');
			this.openTarget[id] = this.openTarget[id] ? '':'open';
		}

	},
	data () {

	    return {
				lang:this.$store.state.lang,
				checkboxInit:{},
				openTarget:{}


	    }
	},
	watch:{
		'$route'(to,from){
			this.openTarget = {};
		}
	}
}


</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:1024px;
}


.content-wrap{
	padding-top:80px;
	background-color: #fffcf7;
	padding-bottom: 120px;
}
.content-wrap>.container{
	display: flex;

}
.content-wrap .list{
	width:200px;
	margin-right: 47px;
	margin-left:11px;
	font-size: 18px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -0.4px;
	color: #41403e;

}

.content-wrap .list>div{
	padding:16px 0;

}
.content-wrap .list>div>div{
	padding:16px 0;


}
.content-wrap .list>div:first-of-type{
	padding-top:0;
}
.content-wrap .list>div~div{
	border-top:1px solid #e6e6e6;
}
.content-wrap .body{
	width:762px;
	padding-left:41px;
	padding-right: 11px;
}
.head-title{
	margin-bottom: 60px;
	font-size: 48px;
	 font-weight: bold;
	 font-style: normal;
	 font-stretch: normal;
	 line-height: 1.33;
	 letter-spacing: -2px;
	 color: #41403e;
	 margin-top: -12px;
}
.section-title{
	font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #999999;
padding-left:32.5px;
	margin-bottom: 4px;
}
.content-title{

  font-size: 32px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -1px;
  color: #41403e;
  width:100%;
}
.question ~ .question{
	margin-top:80px;
}

.question>.content-title{
	padding-left:32.5px;
	position: relative;
}
.question>label>.content-title::before{
	content:url('../../assets/help/img-btn-arrow-wh.svg');
	position: absolute;
	top:0px;
	left:0;
	width:32.5px;
}
.question>label{
	display: block;
	position: relative;
	padding-left:35px
}
.question>input[type=checkbox]{
	display: none;
}
.question>input[type=checkbox]:checked~label>.content-title::before{
	content:url('../../assets/help/img-faq-arrow-down-bl.svg');
	top:2px;
}
.question>.content-title:hover{
	cursor: pointer;
}
.question>.question-body{
	display: none;
	margin-top:13px;
	padding-bottom:80px;
	border-bottom: 1px solid #e6e6e6;
	width:100%;
	font-size: 22px;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: 1.45;
letter-spacing: -0.8px;
color: #41403e;
}
.question>input[type=checkbox]:checked ~ .question-body{
	display: block;
}

.contact-form{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.7px;
  color: #41403e;
}
.contact-form>div~div{
	margin-top:32px;
}
.contact-form>div>input[type=text], .contact-form>div>textarea{
	display: block;
	padding: 18px;
	border: solid 1px #e6e6e6;
  background-color: #ffffff;
  border-radius: 8px;
  margin-top:12px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  width: 100%;

}
.contact-form>div>textarea{
	resize: vertical;
	min-height: 312px;
}


.contact-form #email{
	width: 420px;
}
input:focus, textarea:focus{
	 outline: none !important;
}
.contact-form .blank-error>input[type=text], .form-error>input[type=text], .blank-error>textarea{
	border: solid 2px #f77f73 !important;
}
.contact-form .error-text{
	font-size: 18px;
 font-weight: normal;
 font-style: normal;
 font-stretch: normal;
 line-height: normal;
 letter-spacing: -0.4px;
 color: #f77f73;
 padding-left: 16px;
}
.contact-form>div:last-of-type{
	display: inline-block;
}
.contact-form .submit-btn{
	min-width: 317px;

	 height: 64px;
 border-radius: 36px;
	 border: solid 3px #42c0ff;
 display: flex;
 justify-content: center;
 font-size: 22px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -1px;
	text-align: center;
	color: #42c0ff;
	align-items: center;
}
.contact-form .submit-btn:hover{
	cursor: pointer;
}
.faq-section:hover{
	cursor: pointer;
}
a.router-link-active{
	font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #42c0ff;
}
.search-title{
	font-size: 18px;
 font-weight: normal;
 font-style: normal;
 font-stretch: normal;
 line-height: 1.56;
 letter-spacing: -0.8px;
 color: #999999;
 margin-bottom: 65px;
}
.search-title>span{
	margin-right: 12px;
}
.search-title .searched-word{
	font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.56;
  letter-spacing: -0.8px;
  color: #41403e;
  display: inline-flex;
  margin-right: 26px;
  height: 20px;
  min-width: 20px;

}
.no-result{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -1px;
  color: #41403e;
}
.searched-word >*{
	display: inline-block;
	line-height: 20px;
	position: relative;
}
.search-title .searched-word .remove::before{
	content:url('../../assets/help/icon-key-delete.svg');
	display: inline-block;
	width: 20px;
	height: 20px;
	position: relative;
	top:0;

}
.search-title .searched-word .remove:hover{
	cursor: pointer;
}
.search-title .searched-word .remove:hover::before{
	content:url('../../assets/help/icon-key-delete-over.svg');
}
.move-contact{
	border-top:solid 2px #e6e6e6;
	margin-top:80px;
	padding-top:32px;
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: right;
  color: #42c0ff;
}
.sub-menu{
	display: block;
}
</style>
<style>
.question>.question-body img{
	margin:15px 0;
}
.question-body a:link{
	text-decoration: underline !important;
	color:#42c0ff !important;
}
.question-body a:visited{
	text-decoration: underline !important;
	color:#42c0ff !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/help/AppViewContent.vue